<template>
  <Table :columns="columns" :headers="headers">
    <PropertyTableRow
      v-for="property in properties"
      :key="property.id"
      :property="property"
      :show-portfolio="showPortfolio"
      :show-manager="showManager"
      :title="titleOf?.(property)"
      @select-portfolio="emit('select-portfolio', $event)"
    />
  </Table>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { Table } from '@tallo/design-system';

import { PropertyListItemDto } from '../dtos/property-list-item.dto.interface';
import PropertyTableRow from './property-table-row.vue';

type TitleOf = (property: PropertyListItemDto) => string;

/** The properties as rows, the same facts the cards carry; the columns follow the props */
const props = defineProps<{
  properties: PropertyListItemDto[];
  showPortfolio?: boolean;
  showManager?: boolean;
  /** Names a row in place of the property's name; the first column's header follows */
  titleOf?: TitleOf;
  firstHeader?: string;
}>();
const emit = defineEmits<{ 'select-portfolio': [portfolioId: string] }>();

const layout = computed(() => [
  { header: props.firstHeader ?? 'Property', width: 'minmax(0, 2.4fr)' },
  { header: 'Status', width: '1fr' },
  { header: 'Leads', width: '0.6fr' },
  ...(props.showManager ? [{ header: 'Manager', width: '1.4fr' }] : []),
  ...(props.showPortfolio ? [{ header: 'Portfolio', width: '1.2fr' }] : []),
  { header: 'Listed', width: '1fr' },
]);
const columns = computed(() => layout.value.map(({ width }) => width).join(' '));
const headers = computed(() => layout.value.map(({ header }) => header));
</script>
